/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Match_Male14Inputs */

const en__field_enum_icsrm_match_male14 = /** @type {(inputs: _Field_Enum_Icsrm_Match_Male14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Men`)
};

const de__field_enum_icsrm_match_male14 = /** @type {(inputs: _Field_Enum_Icsrm_Match_Male14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mann`)
};

/**
* | output |
* | --- |
* | "Men" |
*
* @param {_Field_Enum_Icsrm_Match_Male14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_match_male14 = /** @type {((inputs?: _Field_Enum_Icsrm_Match_Male14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Match_Male14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_match_male14(inputs)
	return de__field_enum_icsrm_match_male14(inputs)
});
export { _field_enum_icsrm_match_male14 as "_field_enum_ICSRM_MATCH_MALE" }